import { invokeApi } from "../bl_libs/invokeApi";
import { getAccessToken } from "../utils/authStorage";

export const login_user_api = async (data) => {
  const requestObj = {
    path: `api/partner_auth/login`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const logout_user_api = async () => {
  const requestObj = {
    path: `api/partner_auth/logout`,
    method: "POST",
  };
  return invokeApi(requestObj);
};

export const change_password_api = async (data) => {
  const requestObj = {
    path: `api/partner_auth/change-password`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const user_init_api = async () => {
  const requestObj = {
    path: `api/partner_auth/partner-init`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  };
  return invokeApi(requestObj);
};

export const send_pin_code_api = async (data) => {
  const requestObj = {
    path: `api/partner_auth/send-otp`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const verify_pin_code_api = async (data) => {
  const requestObj = {
    path: `api/partner_auth/verify-otp`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const reset_password_api = async (data) => {
  const requestObj = {
    path: `api/partner_auth/reset-password`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
